import React, { useEffect, useState } from 'react';
import './Temporadas.css';
import { getHistorialEnvios } from '../../services/jugadoresService';

export const ETIQUETAS_ENVIO = {
  APLAZAMIENTO: 'Aviso: partido aplazado',
  ANULACION: 'Aviso: partido anulado',
  PLAZO_PUNTOS: 'Aviso: plazo para comunicar puntos',
  PLAZO_APLAZADO: 'Aviso: plazo para jugar el aplazado',
  LICENCIA: 'Aviso: licencia a punto de caducar',
  PRUEBA: 'Correo de prueba',
  REVISION: 'Solicitud de revisión',
};

// Fecha y hora en horario de Madrid, como las ve la liga.
export const formatearFechaHora = (iso) =>
  new Date(iso).toLocaleString('es-ES', { timeZone: 'Europe/Madrid', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });

// Histórico de correos de un jugador: los que recibe (avisos automáticos y
// pruebas) y las solicitudes de revisión que él mandó al comité.
export default function ModalHistorialEnvios({ jugador, onCerrar }) {
  const [envios, setEnvios] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let vigente = true;
    getHistorialEnvios(jugador.jugador_id)
      .then((datos) => vigente && setEnvios(datos))
      .catch((err) => vigente && setError(err.message || 'No se pudo cargar el histórico.'));
    return () => { vigente = false; };
  }, [jugador.jugador_id]);

  useEffect(() => {
    const alPulsar = (e) => { if (e.key === 'Escape') onCerrar(); };
    document.addEventListener('keydown', alPulsar);
    return () => document.removeEventListener('keydown', alPulsar);
  }, [onCerrar]);

  return (
    <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && onCerrar()}>
      <div className="modal-box historial-modal" role="dialog" aria-modal="true" aria-labelledby="historial-titulo">
        <h3 id="historial-titulo">Histórico de envíos · {jugador.nombre}</h3>

        {error && <p className="error-msg" role="alert">{error}</p>}
        {!error && envios === null && <p className="empty-msg">Cargando…</p>}
        {envios && envios.length === 0 && <p className="empty-msg">Todavía no hay ningún envío de correo de este jugador.</p>}

        {envios && envios.length > 0 && (
          <table className="data-table historial-tabla">
            <thead>
              <tr><th>Fecha</th><th>Tipo</th><th>Detalle</th><th>Resultado</th></tr>
            </thead>
            <tbody>
              {envios.map((e, i) => (
                <tr key={`${e.fecha}-${e.tipo}-${i}`}>
                  <td data-label="Fecha">{formatearFechaHora(e.fecha)}</td>
                  <td data-label="Tipo">
                    {ETIQUETAS_ENVIO[e.tipo] ?? e.tipo}
                    {e.direccion === 'DEL_JUGADOR' && <span className="historial-del-jugador"> (lo manda el jugador)</span>}
                  </td>
                  <td data-label="Detalle">{e.detalle || '—'}</td>
                  <td data-label="Resultado">
                    {e.ok
                      ? <span className="chip chip-success">Enviado</span>
                      : <span className="chip chip-danger" title={e.error ?? ''}>Falló{e.error ? `: ${e.error}` : ''}</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        <p className="historial-nota">
          Los avisos automáticos solo se anotan cuando se envían bien; si uno falla se reintenta al día siguiente.
        </p>
        <div className="modal-footer">
          <button type="button" className="btn btn-primary" onClick={onCerrar}>Cerrar</button>
        </div>
      </div>
    </div>
  );
}
